import UAParserContext from '@/context/ua-parser'
import { ReactNode, useContext } from 'react'
import Toggle from 'ui/src/components/controls/toggle'

type Props = {
    isAlphabetical: boolean
    onChange: (isAlphabetical: boolean) => void
    children?: ReactNode
}

function Sort({ onChange, isAlphabetical, children }: Props) {
    const { deviceType } = useContext(UAParserContext)
    return (
        <div className="m-4 ml-2 flex items-center gap-2 sm:ml-0">
            <span className="text-giphyLightGrey shrink-0 text-base font-bold sm:text-sm">Sort By:</span>
            <div>
                <Toggle
                    isOn={isAlphabetical}
                    onChange={onChange}
                    backgroundColor="transparent"
                    labelOff="Recently Updated"
                    labelOn="Alphabetical"
                    size={deviceType === 'mobile' ? 'mini' : 'medium'}
                />
            </div>
            <div className="w-full" />
            {children}
        </div>
    )
}

export default Sort
